module.exports = __webpack_public_path__ + "img/like.330245ec.svg";